export default {"src":"/_next/static/media/phone.e240958f.svg","height":572,"width":869};